import React from "react";
import logo from "../images/airbnb-logo.svg";

const Header = () => (
    <header>
        <img src={logo} alt="Airbnb logo"/>
    </header>
);

export default Header